import { memo, useEffect } from "react";

function ForceError() {
  useEffect(() => {
    // Intentionally throw an error to simulate a crash
    throw new Error('This is a forced error for testing purposes.');
  }, []);

  return <span>Force Error</span>;
}

export default memo(ForceError);
